<template>
<div id="bind-phone-pop" class="pop" v-show="bindStatus !== 'NO_BIND'" @click.stop="showCodeList = false">
    <div class="maskers"></div>
    <transition name="bind" mode="out-in">
      <div class="identy-pop bind-phone" v-if="bindStatus === 'TO_BIND'" :key="'TO_BIND'">
          <p class="c09 txt-mid2 mgt-30">
              根据《中华人民共和国网路安全法》要求，自6月1日起使用信息发布、即时通讯等互联网服务需进行身份信息验证。为保障您的使用体验，建议您尽快完成手机号绑定验证，感谢您的支持和理解。
          </p>
          <div class="tit-panel1"> <span class="tit">请绑定手机号</span> </div>
          <div class="cont">
              <div class="selecter selecter-s5 selecter-m1 wid-110" :class="{'open': showCodeList}" @click.stop.prevent="toggleCodeList">
                  <div class="selecter-selected">
                      <span class="selecter-text">{{code}}</span>
                      <span class="sel-arrDu">
                          <span href="" class="icon-ic_down iconfont"></span>
                      </span>
                  </div>
                  <div class="selecter-options">
                      <ul>
                          <li class="selecter-item" @click="selectCode(item)" v-for="(item, index) of codeList" >{{item.code}}</li>
                      </ul>
                  </div>
              </div>
              <input v-model="user.account" type="text" class="txt-phone fr" placeholder="请输入手机号码" @blur="checkAccount">
              <p class="txt-errors mgl-120" v-show="!verify.account && jerror.account">{{jerror.account}}</p>
          </div>
          <div class="cont">
              <input type="text" v-model="user.checkCode" class="txt-phone" placeholder="请填写短信验证码">
              <!-- <p class="txt-errors">请填写正确的验证码</p> -->
              <p class="txt-errors" v-show="jerror.checkCode && !verify.checkCode">{{jerror.checkCode}}</p>
              <a href="" class="btn btn-primary txt-code fr" :class="{'disabled' : hasQrCode }" @click.prevent="getQrCode">{{hasQrCode ? `${countDown}s` : '获取验证码'}}</a>
          </div>
          <a class="btn btn-primary block btn-sure" @click.stop.prevent="confirm">确定</a>
      </div>
      <div class="identy-pop bind-phone" v-if="bindStatus === 'BIND_FAILED'" :key="'BIND_FAILED'">
        <span class="inl-b err-cat"></span>
        <p class="err-txt">
            <span class="iconfont icon-ic_test2 err-tip"></span>
            <span class="inl-b tc">该手机已绑定过多账号，<br>请更换其他手机号</span>
        </p>
        <a href="" class="btn btn-primary txt-code mgb-15" @click.stop.prevent="toRebind">重新绑定</a>
      </div>
      <div class="identy-pop bind-phone" v-if="bindStatus === 'BIND_SUCCESS'" :key="'BIND_FAILED'">
        <span class="inl-b suc-cat"></span>
        <p class="suc-txt">
            <span class="iconfont icon-hook suc-tip"></span>绑定成功
        </p>
        <a href="" class="btn btn-primary txt-code mgb-15" @click.stop.prevent="confirmSuc">知道啦</a>
      </div>
    </transition>
</div>
</template>
<script>
var gMsg = {
  phoneError: '手机号格式不正确!',
  phoneEmpty: '请输入手机号!',
  sysError: '系统繁忙！',
  checkCodeEmpty: '请输入验证码',
  checkCodeError: '请输入正确的验证码'
}
import coutries from '@/coutries'
import validator from '@/common/validator'
import api from '@/api'
import { queryHref } from '@/common/utils'
export default {
  props: {
    visible: Boolean
  },
  data () {
    return {
      showCodeList: false,
      codeList: coutries,
      code: '+86',
      hasQrCode: false,
      countDown: '',
      verify: {
        account: false,
        checkCode: false
      },
      jerror: {
        account: '',
        checkCode: ''
      },
      user: {
        account: '',
        checkCode: ''
      }
    }
  },
  methods: {
    confirm () {
      // this.$store.dispatch('')
      this.checkQrCode()
      if (this.verify.checkCode) {
        api.smsVerifyBind({
          phone_num: this.code === '+86' ? this.user.account : (this.code.replace('+', '') + '-' + this.user.account),
          smsCode: this.user.checkCode,
          checkKey: this.checkKey
        }).then(res => {
          if (res.data.ret === 0 || res.data.success) {
            this.$store.commit('changeBindStatus', 'BIND_SUCCESS')
            this.dataIntialize()
          } else {
            this.verify.checkCode = false
            this.jerror.checkCode = res.data.msg
          }

        }).catch(e => console.log(e, e.msg))
      }

    },
    confirmSuc () {
      window.location.href = this.toUrl
      // this.$store.commit('changeBindStatus', 'NO_BIND')
    },
    toRebind () {
      this.dataIntialize()
      this.$store.commit('changeBindStatus', 'TO_BIND')
    },
    toggleCodeList () {
      this.showCodeList = !this.showCodeList
    },
    selectCode (obj) {
      this.code = obj.code
      this.checkAccount()
    },
    checkAccount () {
      this.verify.account = false
      var value = this.user.account.trim()
      if (!value) {
        this.jerror.account = gMsg.phoneEmpty
        return new Promise(resolve => resolve(false))
      }
      if (this.code === '+86' && !validator(value, 'mobile')) {
        this.jerror.account = gMsg.phoneError
        return new Promise(resolve => resolve(false))
      }
      this.verify.account = true
      return new Promise(resolve => resolve(true))
    },
    checkQrCode () {
      var value = this.user.checkCode.trim()
      if (!value) {
        this.verify.checkCode = false
        this.jerror.checkCode = gMsg.checkCodeEmpty
        return false
      }
      if (value.length < 6 || value.length > 6) {
        this.verify.checkCode = false
        this.jerror.checkCode = gMsg.checkCodeError
        return false
      }
      this.verify.checkCode = true
      return true
    },
    getQrCode () {
      if (this.verify.account) {
        api.smsSend({
          sendType: 1,
          msgType: 3,
          phone_num: this.code === '+86' ? this.user.account : (this.code.replace('+', '') + '-' + this.user.account )
        }).then(res => {
          if (res.data.success) {
            this.hasQrCode = true
            this.countDown = 180
            this.Timer && clearInterval(this.Timer)
            this.Timer = setInterval(() => {
              if (this.countDown === 0) {
                clearInterval(this.Timer)
                this.hasQrCode = false
              }
              this.countDown--
            }, 1000)
          } else if (res.data.ret < 0) {
            this.verify.account = false
            this.jerror.account = res.data.msg
          }
        })
        .catch(e => {
          console.log(e.message)
        })
      }
    },
    dataIntialize () {
      this.Timer && clearInterval(this.Timer)
      this.hasQrCode = false
      this.countDown = 0
      this.user.account = ''
      this.user.checkCode = ''
    }
  },
  computed: {
    bindStatus () {
      return this.$store.state.bindPhoneStatus
    },
    checkKey () {
      return this.$store.state.checkKey
    },
    toUrl () {
      return this.$store.state.toUrl
    }
  },
  mounted () {
  },
  destroyed () {
    this.dataIntialize()
  }
}
</script>
<style lang="sass">
#bind-phone-pop
  .bind-enter-active,
  .bind-leave-active
    transition: all .6s ease
  .bind-enter,
  .bind-leave-to
    transform: translate3d(-50%, 50%, 0)
    opacity: 0
</style>



// WEBPACK FOOTER //
// src/components/pop-bindphone.vue